import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const isResizeNoise = (m) => typeof m === "string" && m.includes("ResizeObserver loop");
const report = (message, stack) => {
  if (isResizeNoise(message)) return;
  try {
    const body = JSON.stringify({ message: String(message).slice(0, 1000), stack: String(stack || "").slice(0, 4000), url: window.location.href, ua: navigator.userAgent });
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/gtax/client-error`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
  } catch (e) { /* ignore */ }
};
window.__reportError = report;
window.addEventListener("error", (e) => {
  if (isResizeNoise(e.message)) { e.stopImmediatePropagation(); return; }
  report(e.message, e.error?.stack);
});
window.addEventListener("unhandledrejection", (e) => report(e.reason?.message || String(e.reason), e.reason?.stack));


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
